import { TagsHelper } from "@/helpers";
import type { Dictionary, DictionaryGroup, DictionaryGroupWithDictionaries } from "@/types";

export function addDictionariesToGroups(
  groups: DictionaryGroup[],
  dictionaries: Dictionary[]
): DictionaryGroupWithDictionaries[] {
  return groups.reduce<DictionaryGroupWithDictionaries[]>(
    (groupsWithDictionaries, group) => [
      ...groupsWithDictionaries,
      {
        ...group,
        dictionaries: TagsHelper.filterByTags(dictionaries, group.tags)
      }
    ],
    []
  );
}

export function sortByTagsPriority(groups: DictionaryGroup[]): DictionaryGroup[] {
  const groupsByTitle = [...groups].sort((groupA, groupB) => groupA.title.localeCompare(groupB.title));

  const tagPriority = {
    "group-comp": -1,
    "group-kdict": 1
  };

  return TagsHelper.sortByTags(groupsByTitle, tagPriority);
}
